module.exports = __webpack_public_path__ + "da0828f1b27fa2415e8a0254963f22cd.mp4";